
import { useEffect, useState } from "react";
import { Box, CircularProgress, Typography } from "@mui/material";
import palette from "./utilities/palette";
import { SelectOption } from "./utilities/dropDownOptions";

export default function BuildsLoader({
  schema,
  ecuCataSelectObj,
  dynamicSelectOptionsMap
}: Readonly<{
  schema: any,
  ecuCataSelectObj: any,
  dynamicSelectOptionsMap: Record<string, SelectOption[]>
}>) {
  const isLoadedDynamicSelectOption =
    dynamicSelectOptionsMap.supplier.length > 1;

    const [percentageLoaded, setPercentageLoaded] = useState(0);

    useEffect(() => {
      let loadedItems = 0;
      if (schema) loadedItems += 1;
      if (ecuCataSelectObj) loadedItems += 1;
      if (isLoadedDynamicSelectOption) loadedItems += 1;

      const totalItems = 3;
      const newPercentageLoaded = (loadedItems / totalItems) * 100;
      setPercentageLoaded(newPercentageLoaded);

    }, [schema, ecuCataSelectObj, dynamicSelectOptionsMap]);

  return (
    <div style={{display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'center', height: 'calc(100vh - 15vh)', width: '100%', fontSize: '24px'}}>
            {/* <span style={{paddingLe/ft: '5px'}}><DotFlashing size="large"/></span> */}
            <Box sx={{ position: 'relative' }}>
              <CircularProgress sx={{color: palette.main}} size={100} />
              <Box
                sx={{
                  top: 0,
                  left: 0,
                  bottom: 0,
                  right: 0,
                  position: 'absolute',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                }}
              >
                <Typography
                  variant="caption"
                  component="div"
                  fontSize={'28px'}
                  sx={{ color: palette.main }}
                >{`${Math.round(percentageLoaded)}`}<span style={{fontSize: '20px'}}>%</span></Typography>
              </Box>
            </Box>
    </div>
  );
}